// AI-CONTEXT: See docs/features/participation-ladder.md
import { LADDER_LABELS } from '../../../helpers/participationHelpers/participationOptions'

// De weergave van begin → nu op de participatieladder. Gedeeld door het
// tabblad Participatieladder en de rapportagewidget, zodat een rapport
// dezelfde ladder toont als het dossier. De kleuren staan op
// .participation-ladder-progress zelf, niet op de container van het tabblad.

const LADDER_TREDEN = Object.keys(LADDER_LABELS).map(Number)

/**
 * @param {number|null} step
 * @returns {string} 'Trede 2 · Sociale contacten buitenshuis', of 'Geen trede'
 */
export const ladderLabel = (step) => (step ? `Trede ${step} · ${LADDER_LABELS[step]}` : 'Geen trede')

/**
 * @param {object} props
 * @param {number|null} props.from - Begintrede
 * @param {number|null} props.to - Huidige trede
 */
export const LadderViz = ({ from, to }) => (
    <div className="participation-ladder-viz" aria-hidden="true">
        {LADDER_TREDEN.map((rung) => {
            const isFrom = rung === from
            const isTo = rung === to
            const cls = isTo ? 'rung t1' : isFrom ? 'rung t0' : 'rung'
            return (
                <div key={rung} className={cls}>
                    {isFrom && <span className="pin">Begin</span>}
                    {isTo && rung !== from && <span className="pin">Nu</span>}
                </div>
            )
        })}
    </div>
)

/**
 * @param {object} props
 * @param {number|null|undefined} props.change - Verschil in treden; null = niet te bepalen
 */
export const StepChangePill = ({ change }) => {
    if (change === null || change === undefined) {
        return <span className="participation-step-change"><span className="arrow flat">·</span>n.v.t.</span>
    }
    const arrowCls = change > 0 ? 'arrow' : change < 0 ? 'arrow down' : 'arrow flat'
    const arrow = change > 0 ? '↑' : change < 0 ? '↓' : '·'
    const abs = Math.abs(change)
    return (
        <span className="participation-step-change">
            <span className={arrowCls}>{arrow}</span>
            {abs} {abs === 1 ? 'trede' : 'treden'}
        </span>
    )
}

/**
 * @param {object} props
 * @param {number|null} props.from - Begintrede
 * @param {number|null} props.to - Huidige trede
 */
export const LadderEndResult = ({ from, to }) => (
    <div className="participation-ladder-endresult">
        <span className="endresult-step">{ladderLabel(from)}</span>
        <span className="endresult-arrow" aria-hidden="true">→</span>
        <span className="endresult-step endresult-step-now">{ladderLabel(to)}</span>
    </div>
)

const LadderProgress = { ladderLabel, LadderViz, StepChangePill, LadderEndResult }

export default LadderProgress
